
<div ref="container" class="flow-highlight">
	<div v-if="showSearch" class="f-h-search-panel">
		<SearchInput
			ref="highlight-search"
			placeholder="Search"
			:value.sync="searchKeyword"
			:no-result-tag="showNoResult"
			@keyup="highlightKeyword($event)"
		/>
	</div>
	<pre v-highlightjs="content" :wrap="wrap">
	<code ref="code" class="flow-highlight-code" :class="[highlightClass]" :wrap="wrap" />
	</pre>
</div>
